import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import NativeSelect from "@meetyoo/components/src/components/Selects/NativeSelect";

import { setLanguage } from "../../../actions/ui";

const LANGUAGE_OPTIONS = ["en", "de"];

function languageForSelect(stored) {
  const base = (stored || "en").split("-")[0].toLowerCase();
  return LANGUAGE_OPTIONS.includes(base) ? base : "en";
}

export const AppbarSettingsComponent = ({ translate, language, setLanguageFn }) => {
  const [openSettings, setOpenSettings] = useState(false);
  const modalContentRef = useRef(null);

  useEffect(() => {
    if (openSettings && modalContentRef.current) {
      modalContentRef.current.focus();
    }
  }, [openSettings]);

  return [
    <Modal
      key="settings"
      open={openSettings}
      onClose={() => setOpenSettings(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={openSettings}>
        <Box
          ref={modalContentRef}
          tabIndex={-1}
          sx={theme => ({
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            outline: "none",
          })}
        >
          <h2>{translate.settings}</h2>
          <NativeSelect
            value={translate.language}
            currentSelect={languageForSelect(language)}
            selectValues={LANGUAGE_OPTIONS}
            onChange={e => setLanguageFn(e.target.value)}
          />
          <div>version: 17042025</div>
          <Button sx={{ mt: 2 }} variant="outlined" onClick={() => setOpenSettings(false)}>
            Close
          </Button>
        </Box>
      </Fade>
    </Modal>,
    <IconButton
      key="settingsButton"
      aria-label="Settings for current user"
      aria-controls="settings-appbar"
      aria-haspopup="true"
      onClick={() => setOpenSettings(true)}
      color="inherit"
      size="large">
      <SettingsIcon />
    </IconButton>,
  ];
};

AppbarSettingsComponent.propTypes = {
  setLanguageFn: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({ translate: state.ui.translate, language: state.ui.language });

const mapDispatchToProps = dispatch => ({
  setLanguageFn: language => dispatch(setLanguage(language)),
});

const AppbarSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppbarSettingsComponent);

export default AppbarSettings;
